import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { IconCommunicationCall16 } from '@cian/ui-kit-design-tokens/icons';

import { useSelector } from 'react-redux';
import { useCallbackButton } from './useCallbackButton';
import { getBuilderChatEnabled } from '../../selectors/builderChat';
import { selectNewbuildingKpnChatEnabled } from '../../selectors/consultantChat/selectNewbuildingKpnChatEnabled';
import { useApplicationContext } from '../../utils/withApplicationContext';

export function BasicCallbackButton() {
  const [isAvailable, handleClick, isLoading] = useCallbackButton('blockJK');

  const { config } = useApplicationContext();

  const isBuilderChatEnabled = useSelector(getBuilderChatEnabled);
  const isKpnChatsEnabled = useSelector(selectNewbuildingKpnChatEnabled);
  const isKpnChatsFlagEnabled = config.get<boolean>('newbuilding-card-desktop-fichering-frontend.KpnChat.Enabled');
  const isConsultantChatVisible = isKpnChatsEnabled && isKpnChatsFlagEnabled;

  const isAnyChatAvailable = isBuilderChatEnabled || isConsultantChatVisible;

  if (!isAvailable) {
    return null;
  }

  return (
    <Button
      theme="fill_white_primary"
      size={'M'}
      beforeIcon={<IconCommunicationCall16 color={'icon-main-default'} />}
      onClick={handleClick}
      loading={isLoading}
      aria-label="Заказ звонка"
      data-testid="BasicCallbackButton"
    >
      {isAnyChatAvailable ? undefined : 'Перезвоните мне'}
    </Button>
  );
}
